import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ManualPage from "./pages/ManualPage";
import RentalPage from "./pages/RentalPage";
import ServicesPage from "./pages/ServicesPage";
import MainLayout from "./layouts/MainLayout";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter>
		<Routes>
			<Route element={<MainLayout />}>
				<Route path="/" element={<App />} />
				<Route path="/about" element={<AboutPage />} />
				<Route path="/Contact" element={<ContactPage />} />
				<Route path="/manual" element={<ManualPage />} />
				<Route path="/rental" element={<RentalPage />} />
				<Route path="/services" element={<ServicesPage />} />
			</Route>
		</Routes>
	</BrowserRouter>
);
